module.exports = __webpack_public_path__ + "img/onda.bf7f2aa0.svg";